import type { ReactNode } from 'react'
import { cn } from '@/lib/cn'

export interface KeyValueItem {
  label: ReactNode
  value: ReactNode
  /** Monospace + tabular numbers for codes and quantities. */
  mono?: boolean
  hint?: ReactNode
}

/** Label/value list. `columns="auto"` puts pairs side by side on wider screens. */
export function KeyValue({
  items,
  className,
  columns = 1,
}: {
  items: KeyValueItem[]
  className?: string
  columns?: 1 | 2 | 'auto'
}) {
  return (
    <dl
      className={cn(
        'grid gap-x-6',
        columns === 2 && 'grid-cols-1 sm:grid-cols-2',
        columns === 'auto' && 'grid-cols-[repeat(auto-fill,minmax(220px,1fr))]',
        className,
      )}
    >
      {items.map((it, i) => (
        <div
          key={i}
          className="flex items-baseline justify-between gap-4 border-b border-rule/70 py-2.5 last:border-b-0"
        >
          <dt className="min-w-0 flex-1 text-[13px] text-muted">{it.label}</dt>
          <dd
            className={cn(
              'min-w-0 max-w-[62%] break-words text-right text-[14px] text-ink',
              it.mono && 'font-mono tabular',
            )}
          >
            {it.value}
            {it.hint && <div className="text-[12px] text-muted">{it.hint}</div>}
          </dd>
        </div>
      ))}
    </dl>
  )
}
